import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const municipio = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/municipio`,
    namespaced : true,        
    state: {
        municipios: [],
        municipiosbyelemento: [],
        ConteoIndicadoresMun: 0,
        ConteoMunconIntervencion: 0
    }
}).get({
    action: "getMunicipiosbyelemento", 
    path: function (obj) {
        return `/${obj.idsubregion}/${obj.iddepartamento}`;
    },           
    onSuccess: (state, payload) => {        
        state.municipiosbyelemento = payload.data;
    }
}).get({
    action: "getConteoIndicadoresMunicipales", 
    path: function (obj) {
        return `ConteoIndicadoresMunicipales/${obj.iddepartamento}`;
    },           
    onSuccess: (state, payload) => {        
        state.ConteoIndicadoresMun = payload.data;
    }
}).get({
    action: "getConteoMunconIntervencion", 
    path: function (obj) {
        return `ConteoMunicipiosconIntervencion/${obj.iddepartamento}/${obj.idindicador}`;
    },           
    onSuccess: (state, payload) => {        
        state.ConteoMunconIntervencion = payload.data;
    }
}).get({
    action: "getMunicipiospdet", 
    path: function (obj) {
        return `list/${obj.pdet}`;
    },           
    onSuccess: (state, payload) => {        
        state.municipios = payload.data;
    }
}).getStore();

municipio.getters = {  
    gMunicipios : state =>  {
        return state.municipios;
    },
    gMunicipiosByelemento : state => {
        return state.municipiosbyelemento;
    },
    gconteoindicadoresmun : state => {
        return state.ConteoIndicadoresMun;
    },
    gconteomunconintervencion : state => {
        return state.ConteoMunconIntervencion;
    }
}

export default municipio;
